export class myStorage {
    /**
     *
     * @param {*} key  获取的key
     */
    constructor(key) {
        this.key = key;
    }
    // 设置存储
    // key:需要存储的数据 直接全局key
    // value:需要存储的数据
    // expres：过期时间，毫秒单位 number 类型 ，如果为 'fixed' 则在 0 点清除
    setItem(value, expires) {
        // 判断 expires 是否为 'fixed', 如果是则计算出 当前时间到 0 点的毫秒差
        if (expires === 'fixed') {
            expires = (new Date(new Date().toLocaleDateString()).getTime() + (24 * 60 * 60 * 1000)) - new Date().getTime();
        };
        let obj = {
            value: value,
            expires: expires,//有效时间
            startTime: new Date().getTime()//记录存储数据的时间，转换为毫秒值存下来
        }
        // 判断是否设置了有效时间
        if (obj.expires) {
            // 如果设置了时间，把obj转换数据类型转换为字符串对象存起来
            localStorage.setItem(`${this.key}`, JSON.stringify(obj))
        }
        // 如果没有设置有效时间，直接把value值存进去
        else {
            localStorage.setItem(`${this.key}`, JSON.stringify(obj.value))
        }
    }

    // 获取存储数据
    getItem() {
        // 先定义一个变量临时存放提取的值
        try {
            let temp = JSON.parse(localStorage.getItem(`${this.key}`));
            // 判断有没有设置expires属性
            // 如果有，就需要判断是否到期了
            if (temp && temp.expires) {
                let data = new Date().getTime();
                if (data - temp.startTime > temp.expires) {
                    // 此时说明数据已过期,清除掉
                    localStorage.removeItem(`${this.key}`);
                    // 直接return
                    return false;

                }
                else {
                    // 如果没有过期就输出
                    return temp.value
                }
            } else {
                // 如果没有设置，直接输出
                return temp
            }
        } catch (err) {
            //说明没有值
            console.log(err);
            return false;

        }

    }
    //移出缓存
    removeItem(name) {
        localStorage.removeItem(name);
    }
    //移出全部缓存
    clear() {
        localStorage.clear();
    }
}
